import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';
import { Palette } from '@material-ui/core/styles/createPalette';

import { overrides, themeOnlyOverrides } from './overrides';
import { palette } from './palette';
import './theme-augmentation';
import { legacyTypography, typography } from './typography';

export const theme = createMuiTheme({
  palette,
  typography: (palette: Palette) => typography(palette),
  overrides: { ...overrides, ...themeOnlyOverrides },
  legacy: false,
});

export const legacyTheme = createMuiTheme({
  palette,
  typography: (palette: Palette) => legacyTypography(palette),
  overrides,
  legacy: true,
});
